export const situacaoImovel = [
  {id: 'PROPRIETARIO', nome: 'Proprietário'},
  {id: 'POSSEIRO', nome: 'Posseiro'},
  {id: 'ASSENTADO_REFORMA_AGRARIA', nome: 'Assentado da Reforma Agrária'},
  {id: 'QUILOMBOLA', nome: 'Quilombola'},
  {id: 'INDIGENA', nome: 'Indígena'},
  {id: 'OUTROS', nome: 'Outros'},
  {id: 'NAO_DESEJO_ESPECIFICAR', nome: 'Não desejo especificar'}
]

export const tipoPosse = [
  {id: 'COMPRA_E_VENDA', nome: 'Compra e venda'},
  {id: 'ARRENDAMENTO', nome: 'Arrendamento'},
  {id: 'COMODATO', nome: 'Comodato'},
  {id: 'PARCERIA', nome: 'Parceria'},
  {id: 'OUTROS', nome: 'Outros'}
]

export const documentoReformaAgraria = [
  {id: 'NUMERO_RB', nome: 'Número da relação de beneficiário (RB)'},
  {id: 'CONDICAO_PDRU', nome: 'Condição de direito real de uso (PDRU)'},
  {id: 'TITULO_ORGAO', nome: 'Título emitido pelo órgão responsável'},
  {id: 'OUTRO', nome: 'Outro documento'}
]

export const documentoQuilombo = [
  {id: 'NUMERO_RB', nome: 'Número da RB'},
  {id: 'NUMERO_CDRU', nome: 'Número do CDRU'},
  {id: 'TITULO', nome: 'Título'},
  {id: 'OUTRO', nome: 'Outro documento'}
]



// WEBPACK FOOTER //
// ./src/libs/constants/imovel.js